if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.eventMouseEnterHappened = false;

        // Get quantity input and buttons
        this.quantityInput = this.querySelector('.quantity__input');
        this.plusButton = this.querySelector('.quantity__button[name="plus"]');
        this.minusButton = this.querySelector('.quantity__button[name="minus"]');

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.infoButtonDesktop && this.mqlTablet.matches) {
          this.popoverInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.infoButtonDesktop.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('mouseleave', this.closePopover.bind(this));
        }

        // Add inventory validation
        if (this.quantityInput) {
          this.quantityInput.addEventListener('change', this.validateInventory.bind(this));
        }

        if (this.plusButton) {
          this.plusButton.addEventListener('click', () => {
            setTimeout(() => this.validateInventory(), 50);
          });
        }
      }

validateInventory() {
  if (!this.quantityInput) return;

  const inventoryQty = parseInt(this.quantityInput.dataset.inventoryQuantity);
  const inventoryPolicy = this.quantityInput.dataset.inventoryPolicy;
  const inventoryManagement = this.quantityInput.dataset.inventoryManagement;
  const currentValue = parseInt(this.quantityInput.value);
  const variantId = this.quantityInput.dataset.quantityVariantId;

  // Only validate if inventory is tracked and overselling is denied
  if (inventoryManagement !== 'shopify' || inventoryPolicy === 'continue') {
    return;
  }

  // Check if quantity exceeds available inventory
  if (currentValue > inventoryQty) {
    // Set to max available
    this.quantityInput.value = inventoryQty;
    
    // Show error message
    this.showError(variantId, inventoryQty);
  }
  // Don't clear error here - let the timeout handle it
}
      showError(variantId, maxQty) {
        const mobileError = document.getElementById('Quick-order-list-item-error-mobile-' + variantId);
        const desktopError = document.getElementById('Quick-order-list-item-error-desktop-' + variantId);
        const variantRow = document.getElementById('Variant-' + variantId);
        const desktopRow = variantRow ? variantRow.nextElementSibling : null;

        const errorMessage = 'Der er kun ' + maxQty + ' tilgængelig' + (maxQty !== 1 ? 'e' : '') + '.';

        // Show mobile error
        if (mobileError) {
          const errorText = mobileError.querySelector('.variant-item__error-text');
          if (errorText) {
            errorText.textContent = errorMessage;
          }
          mobileError.classList.remove('hidden');
        }

        // Show desktop error
        if (desktopError && desktopRow) {
          const errorText = desktopError.querySelector('.variant-item__error-text');
          if (errorText) {
            errorText.textContent = errorMessage;
          }
          desktopRow.classList.remove('hidden');
        }
      }

      clearError(variantId) {
        const mobileError = document.getElementById('Quick-order-list-item-error-mobile-' + variantId);
        const desktopError = document.getElementById('Quick-order-list-item-error-desktop-' + variantId);
        const variantRow = document.getElementById('Variant-' + variantId);
        const desktopRow = variantRow ? variantRow.nextElementSibling : null;

        if (mobileError) {
          const errorText = mobileError.querySelector('.variant-item__error-text');
          if (errorText) {
            errorText.textContent = '';
          }
          mobileError.classList.add('hidden');
        }

        if (desktopError && desktopRow) {
          const errorText = desktopError.querySelector('.variant-item__error-text');
          if (errorText) {
            errorText.textContent = '';
          }
          desktopRow.classList.add('hidden');
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        if ((this.mql.matches && !isExpanded) || event.type === 'click') {
          button.setAttribute('aria-expanded', !isExpanded);

          this.popoverInfo.toggleAttribute('hidden');

          button.classList.toggle('quantity-popover__info-button--open');

          this.infoButtonDesktop.classList.add('quantity-popover__info-button--icon-only--animation');
        }

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
          button.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') {
              this.closePopover(e);
            }
          });
        }
      }

      closePopover(event) {
        event.preventDefault();
        const isButtonChild = this.infoButtonDesktop.contains(event.relatedTarget);
        const isPopoverChild = this.popoverInfo.contains(event.relatedTarget);

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

        if (!isButtonChild && !isPopoverChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
          this.infoButtonDesktop.classList.remove('quantity-popover__info-button--icon-only--animation');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}